import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import LoaderNew from './LoaderNew';

const Button = styled.button`
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff;
  outline: 1px solid #e1eaff;
  color:rgb(62, 81, 123);
  font-size: 11px;
  height: ${(props) => props.height ? props.height : '24px'};
  max-height: ${(props) => props.height ? props.height : '24px'};
  padding: 3px 16px;
  border-radius: 20px;
  text-align: center;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) => (props.loading ? 'rgb(141, 170, 217)' : props.disabled ? 'rgb(225, 234, 255)' : 'rgb(225, 234, 255)')};
  width: ${(props) => props.minWidth ? props.minWidth : 'auto'};
  min-width: ${(props) => props.minWidth || '100px'};
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  &:hover {
    color: rgb(18, 18, 18);
    outline: 1px solid rgb(186, 205, 235);
  }
`;

const AnimatedButton = ({ loading, variant = 'success', onClick, children, minWidth = '100px', height = '24px' }) => {
  const [showVariant, setShowVariant] = useState(false);
  const [clicked, setClicked] = useState(false);
  const wasLoading = useRef(false);
  const hideTimer = useRef(null);

  useEffect(() => {
    if (clicked && wasLoading.current && !loading) {
      const showTimer = setTimeout(() => {
        setShowVariant(true);

        hideTimer.current = setTimeout(() => {
          setShowVariant(false);
        }, 3000);

      }, 0);

      return () => {
        clearTimeout(showTimer);
        clearTimeout(hideTimer.current);
      };
    }

    wasLoading.current = loading;
  }, [loading, clicked]);

  const handleClick = (e) => {
    setClicked(true);
    setShowVariant(false);
    clearTimeout(hideTimer.current);
    onClick(e);
  };

  return (
    <Button onClick={handleClick} loading={loading} disabled={loading} height={height} minWidth={minWidth}>
      {loading && <LoaderNew style={{ zoom: 0.8 }} color="#FFF" />}
      {!loading && showVariant && variant === 'success' && <CheckRoundedIcon style={{ fontSize: '20px', color: 'green' }} />}
      {!loading && showVariant && variant === 'error' && <ClearRoundedIcon style={{ fontSize: '20px', color: 'red' }} />}
      {!loading && !showVariant && children}
    </Button>
  );
};

export default AnimatedButton;
